module.exports = __webpack_public_path__ + "img/amex.4bf30de9.svg";